import { useQuery } from '@tanstack/react-query';

import { Location } from '../../types/Location';
import { getLocations } from '../Locations';

export const useGetLocations = (isEnabled = true) => {
    const {
        data: locations,
        isLoading: isLoadingLocations,
        error: locationsError
    } = useQuery<Array<Location>>({
        queryKey: ['locations'],
        queryFn: getLocations,
        retry: false,
        enabled: isEnabled
    });

    return { locations, isLoadingLocations, locationsError };
};
